import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import PatVisitRightSideBarRow from './PatVisitRightSideBarRow';
import PostEncounterMsgWidget from './PostEncounterMsgWidget';
import AlertWidget from './AlertWidget';
import { Link } from 'react-router-dom';
import PostEncounterMsgPopup from './PostEncounterMsgPopup';
import AlertPopup from './AlertPopup';
import setUiMessage from '../../Utilities/Tostify';

import { useSelector } from 'react-redux';

function PatVisitRightSidebar({ appId, headerData, patientId }) {
  const [allData, setAllData] = useState(null);
  const [reload, setReload] = useState(false);
  const { globalReload } = useSelector((store) => store.app);

  function handleReload() {
    setReload(!reload);
  }
  const [alertPopup, setAlertPopup] = useState(false);
  const [postEncounterMsgPopup, setPostEncounterMsgPopup] = useState(false);
  const { patAlertData } = useSelector((state) => state.appointment);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ProgressNote/rightSideWidget',
          {
            appointmentId: appId,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [appId, reload, globalReload]);

  const handleAlertPopupOpen = () => {
    setAlertPopup(true);
  };

  const handlePostEncMsgPopupOpen = () => {
    setPostEncounterMsgPopup(true);
  };

  return (
    <>
      <div>
        <div className="chart-right-sect-widget">
          <div className="chart-right-sect-widget-hdr qrt-s-active-t">
            Documents
          </div>
          <div className="chart-right-sect-widget-body">
            {allData?.docDetailArr &&
              allData?.docDetailArr.map((data, i) => {
                return (
                  <div
                    key={i}
                    className={`chart-rt-sec-rt-rw grid-sec ${
                      i % 2 !== 0 ? 'alt-rw ' : ''
                    }`}
                  >
                    <PatVisitRightSideBarRow
                      data={data}
                      handleReload={handleReload}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="chart-right-sect-widget">
          <div className="chart-right-sect-widget-hdr">PCP & Ref. Provider</div>
          <div className="chart-right-sect-widget-body">
            <div className="chart-rt-sec-rt-rw grid-sec">
              <div className="chrt-doc-sec-dt grid-sec">
                <span className="sec-colr width100">
                  Primary care physicain:
                </span>
                <span className="width100"> {allData?.pcpRefDetail?.pcp} </span>
                {/* <span className="width100"> Amanda Boothe, B.A., PSY </span> */}
              </div>
            </div>
            <div className="chart-rt-sec-rt-rw grid-sec alt-rw">
              <div className="chrt-doc-sec-dt grid-sec clear-top10">
                <span className="sec-colr width100">Ref Provider:</span>
                <span className="width100">
                  {allData?.pcpRefDetail?.refProv}
                </span>
                {/* <span className="width100">Angela Martin, MSW, LCSW </span> */}
              </div>
            </div>
            <div className="chart-rt-sec-rt-rw grid-sec">
              <div className="chrt-doc-sec-dt grid-sec clear-top10">
                <span className="sec-colr width100">
                  {allData?.pcpRefDetail?.specialityOne}:
                </span>
                <span className="width100">
                  {' '}
                  {allData?.pcpRefDetail?.specOneName}{' '}
                </span>
                {/* <span className="sec-colr width100">Therapist:</span>
						<span className="width100"> Elizabeth Sparks </span> */}
              </div>
            </div>
            <div className="chart-rt-sec-rt-rw grid-sec alt-rw">
              <div className="chrt-doc-sec-dt grid-sec clear-top10">
                <span className="sec-colr width100">
                  {allData?.pcpRefDetail?.specialityTwo}:
                </span>
                <span className="width100">
                  {allData?.pcpRefDetail?.specTwoName}{' '}
                </span>
                {/* <span className="sec-colr width100">Dentist:</span>
						<span className="width100">Benitez, jackson </span> */}
              </div>
            </div>
            <p className="wdgt-no-info-msg hide">No PCP & Ref!!</p>
          </div>
        </div>
        <div className="chart-right-sect-widget hide">
          <div className="chart-right-sect-widget-hdr">
            <span className="">Post-encounter message</span>
            <span onClick={handlePostEncMsgPopupOpen}>
              <Link className="right fontsize13">Record</Link>
            </span>
          </div>
          <div className="chart-right-sect-widget-body">
            <PostEncounterMsgWidget />
          </div>
        </div>
        <div className="chart-right-sect-widget">
          <div className="chart-right-sect-widget-hdr">
            <span className="">Alert</span>
            <span onClick={handleAlertPopupOpen}>
              <Link className="right fontsize13">Record</Link>
            </span>
          </div>
          <div className="chart-right-sect-widget-body">
            {patAlertData?.getSpecificAlertData &&
              patAlertData?.getSpecificAlertData.map((data, i) => {
                return (
                  <div
                    key={i}
                    className={`chart-rt-sec-rt-rw grid-sec ${
                      i % 2 !== 0 ? 'alt-rw ' : ''
                    }`}
                  >
                    <AlertWidget
                      data={data}
                      headerData={headerData}
                      handleReload={handleReload}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      {alertPopup && (
        <AlertPopup
          headerData={headerData}
          patientId={patientId}
          handleReload={handleReload}
          alertNotifyCheck={
            patAlertData?.alertActive?.active_alert_notification
          }
          close={() => setAlertPopup(false)}
        />
      )}

      {postEncounterMsgPopup && (
        <PostEncounterMsgPopup
          headerData={headerData}
          close={() => setPostEncounterMsgPopup(false)}
        />
      )}
    </>
  );
}

export default PatVisitRightSidebar;
